import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const CustomModal = props => (<Modal
  size={props.size}
  isOpen={props.openModal}
  toggle={props.backdrop === false ? () => {
  } : props.cancelEvent}
  className={"custom-modal-container " + props.className}
  backdrop={props.backdrop || true}
>
  <ModalHeader toggle={props.cancelEvent}>{props.title}</ModalHeader>
  <ModalBody>
    {props.child ? props.child : <div dangerouslySetInnerHTML={{ __html: props.modalBodyContent }}></div>}
  </ModalBody>
  {props.noButtons ? ("") : (<ModalFooter>
    {!props.useOneButton && (<>
      <button className="insta-button-primary" onClick={props.okayEvent}>
        {props.okayText}
      </button>
      &nbsp;&nbsp;
    </>)}
    <button className="insta-button-primary" onClick={props.cancelEvent}>
      {props.cancelText}
    </button>
  </ModalFooter>)}
</Modal>);

export default CustomModal;

CustomModal.defaultProps = {
  okayText: "OKAY",
  cancelText: "CANCEL",
  modalBodyContent: "",
  child: "",
  openModal: false,
  className: "",
  useOneButton: false,
  noButtons: false
};

CustomModal.propTypes = {
  okayText: PropTypes.string,
  cancelText: PropTypes.string,
  modalBodyContent: PropTypes.string,
  child: PropTypes.node,
  okayEvent: PropTypes.func,
  cancelEvent: PropTypes.func,
  openModal: PropTypes.bool,
  className: PropTypes.string,
  useOneButton: PropTypes.bool,
  noButtons: PropTypes.bool
};
